import { District, EducationLevel } from '@/apis/types'

import { HeadingTitleBlock } from '@/components/HeadingTitleBlock/HeadingTitleBlock'

interface HeaderStatistikProps {
  jenjang: EducationLevel
  year: number
  district?: District
  title: string
}

export const HeaderStatistik = ({
  jenjang,
  year,
  district,
  title,
}: HeaderStatistikProps) => {
  const withYear = year ? `&year=${year}` : ''
  const withJenjang = jenjang ? `&jenjang=${jenjang.name}` : ''

  const backHref = `/dataset?district=${district?.id}${withYear}${withJenjang}`

  return (
    <>
      <HeadingTitleBlock
        withBackButton={true}
        withMapOverlay={true}
        backButtonHref={backHref}
        title={title}
        desc=""
        className="py-12"
        trackerGaEventName="dataset"
        trackerPageTitle="Dataset"
      />
    </>
  )
}
